import http, { API_BASE } from './http'
import type { BridgeStatusResponse, PairCode } from '@/types/api'

export const bridgeService = {
  async status(): Promise<BridgeStatusResponse> {
    const { data } = await http.get<BridgeStatusResponse>('/bridge/status')
    return data
  },

  downloadUrl(): string {
    return `${API_BASE}/bridge/download`
  },

  async pairCode(): Promise<PairCode> {
    const { data } = await http.post<PairCode>('/bridge/pair-code')
    return data
  },

  async unpair(): Promise<void> {
    await http.post('/bridge/unpair')
  },
}
